import { render, staticRenderFns } from "./Trapezoid.vue?vue&type=template&id=6043cd9c&"
import script from "./Trapezoid.vue?vue&type=script&lang=js&"
export * from "./Trapezoid.vue?vue&type=script&lang=js&"
import style0 from "./Trapezoid.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports